import { getNativeInfo } from '@docs/common'
import axios, { AxiosRequestConfig, AxiosResponse } from 'axios'
import { getCommunityDomain, getMallDomain } from 'common/util'

/** -100 作为打断的 Code */
export const CANCELED_CODE = -100


interface ResponseData<T> {
  code: number
  msg: string
  data: T
}

async function request<T>(
  url: string,
  config?: Omit<AxiosRequestConfig, 'url'>,
  extra?: { [k: string]: number | string | boolean }
) {
  const { token } = await getNativeInfo()
  const headers = extra?.ignoreAuthToken ? {} : token ? { 'X-Auth-Token': token } : {}
  const requestConfig = {
    url,
    withCredentials: false,
    ...config,
    headers: { ...headers, ...config?.headers },
  }
  return axios
    .request<any, AxiosResponse<T>>(requestConfig)
    .then(response => response.data)
    .catch(thrown => {
      if (axios.isCancel(thrown)) {
        // 避免被判断为 void 返回值
        return { code: CANCELED_CODE } as T
      } else {
        throw thrown
      }
    })
}

export const getVariantsBySKUList = async (skuList: string[], store_area: string) => {
  const baseUrl = await getMallDomain()
  return request<
    ResponseData<{
      productVariants: {
        edges: { node: IProduct }[]
      }
    }>
  >(`${baseUrl}/n/api/getVariantsBySKUList`, {
    method: 'POST',
    data: {
      skuList: Array.from(new Set(skuList)),
      // start_ai_generated
      store_area,
      // end_ai_generated
    },
  }).then(res => {
    if (res.code === 0 && res.data.productVariants) {
      return res.data.productVariants.edges.map(item => item.node)
    } else {
      return []
    }
  })
}

export const getCommunityTopicDetail = (id: number) => {
  return request<ITopicDetail>(`${getCommunityDomain()}/t/${id}/1.json`, {}, { ignoreAuthToken: true })
}

// 浏览器埋点上报
export const uploadTrackingEvents = async (params: Record<string, unknown>) => {
  // 接口放在eufy-security-mall 项目中，调用中间件处理接口 /n/api/trackEvents
  return request(`${await getMallDomain()}/n/api/trackEvents`, {
    method: 'POST',
    data: params
  })
}


export default request
